/*
  PDP gallery controls for the left-thumbnail-rail layout (≥750px).
  Desktop shows only the .is-active slide, so the theme's scroll-based prev/next
  can't move it. Here prev/next step through the thumbnails instead (wrapping),
  and the "1 / N" counter follows whichever thumbnail is current.
  Below 750px the theme's own swipe slider is left alone.
*/
(function () {
  var desktop = window.matchMedia('(min-width: 750px)');

  function init(gallery) {
    if (gallery.dataset.pdpGallery) return;
    gallery.dataset.pdpGallery = 'true';

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var rail = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer || !rail) return;

    var prev = viewer.querySelector('.slider-buttons button[name="previous"]');
    var next = viewer.querySelector('.slider-buttons button[name="next"]');
    var current = viewer.querySelector('.slider-counter--current');
    var total = viewer.querySelector('.slider-counter--total');

    function items() {
      return Array.prototype.filter.call(
        rail.querySelectorAll('[data-target]'),
        function (el) { return !el.classList.contains('slick-cloned'); }
      );
    }

    function activeIndex(list) {
      for (var i = 0; i < list.length; i++) {
        var b = list[i].querySelector('button');
        if (b && b.hasAttribute('aria-current')) return i;
      }
      return 0;
    }

    function syncCounter() {
      if (!desktop.matches) return;
      var list = items();
      if (current) current.textContent = activeIndex(list) + 1;
      if (total) total.textContent = list.length;
    }

    function enableButtons() {
      if (!desktop.matches) return;
      [prev, next].forEach(function (b) { if (b) b.removeAttribute('disabled'); });
    }

    function step(dir) {
      var list = items();
      if (list.length < 2) return;
      var i = (activeIndex(list) + dir + list.length) % list.length;
      var btn = list[i].querySelector('button');
      if (btn) btn.click(); // media-gallery.js swaps the main image + aria-current

      var track = rail.querySelector('.thumbnail-list.slick-initialized');
      if (track && window.jQuery) window.jQuery(track).slick('slickGoTo', i);
      else list[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    // Capture phase: runs before slider-component's own scroll handler on the button.
    gallery.addEventListener('click', function (e) {
      if (!desktop.matches) return;
      var btn = e.target.closest('.slider-buttons button[name="previous"], .slider-buttons button[name="next"]');
      if (!btn || !viewer.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      step(btn.name === 'next' ? 1 : -1);
    }, true);

    // Arrow keys step through the photos while the gallery has focus (mockup galKey).
    if (!viewer.hasAttribute('tabindex')) viewer.setAttribute('tabindex', '0');
    gallery.addEventListener('keydown', function (e) {
      if (!desktop.matches || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
      if (e.target.closest('input, textarea, select')) return;
      e.preventDefault();
      step(e.key === 'ArrowRight' ? 1 : -1);
    });

    // Counter follows the current thumbnail however it changes (click, arrows, variant switch).
    new MutationObserver(syncCounter).observe(rail, {
      subtree: true, attributes: true, attributeFilter: ['aria-current']
    });

    // slider-component disables the buttons at its "ends"; arrows wrap here, so keep them live.
    [prev, next].forEach(function (b) {
      if (b) new MutationObserver(enableButtons).observe(b, { attributes: true, attributeFilter: ['disabled'] });
    });

    // slider-component rewrites the counter on scroll/resize; restore ours afterwards.
    if (current) new MutationObserver(function () {
      var want = String(activeIndex(items()) + 1);
      if (desktop.matches && current.textContent !== want) current.textContent = want;
    }).observe(current, { childList: true, characterData: true, subtree: true });

    syncCounter();
    enableButtons();
  }

  function run() {
    document
      .querySelectorAll('.main-product-template .product--thumbnail_slider_left media-gallery')
      .forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  document.addEventListener('shopify:section:load', run);
})();
